import Vue from "vue";
import * as moment from "moment";

Vue.mixin({
  data() {
    return {
      //
    };
  },
  methods: {
    formatDateForParam(value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD");
      } else {
        return null
      }
    },
    convertToAngka(rupiah) {
      if (rupiah == "") {
        return 0;
      } else {
        return parseInt(rupiah.replace(/,.*|[^0-9]/g, ""), 10);
      }
    },
    convertToRupiah(angka) {
      var rupiah = "";
      var angkarev = angka
        .toString()
        .split("")
        .reverse()
        .join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return rupiah
        .split("", rupiah.length - 1)
        .reverse()
        .join("");
    },
    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    enterNumbers(event) {
      // allow only number and arrow
      if ((event.code == 'ArrowLeft') || (event.code == 'ArrowRight') ||
         (event.code == 'ArrowUp') || (event.code == 'ArrowDown') || 
         (event.code == 'Delete') || (event.code == 'Backspace')) {
         return;
      } else if (event.key.search(/\d/) == -1) {
        event.preventDefault();
      }
    }
  }
});

export default Vue;
